export default {
  en: {    
  	cars: {
      'car-basic': 'Car',
      'car-light-van': 'Light van',
      'car-delivery-van': 'Delivery van',
      'car-delivery-van-xl': 'Delivery van XL',
      'car-box-van': 'Box van',
      'car-truck-5k': 'Truck 5 ton',
      'car-truck-10k': 'Truck 10 ton',
      'car-semi-trailer': 'Semi-trailer',
      'car-truck-trailer': 'Truck-trailer'
  	}
  },
  nl: {    
  	cars: {
      'car-basic': 'Personenwagen',
      'car-light-van': 'Lichte bestelwagen',
      'car-delivery-van': 'Bestelwagen',
      'car-delivery-van-xl': 'Bestelwagen XL',
      'car-box-van': 'Meubeltruck',
      'car-truck-5k': 'Vrachtwagen 5 ton',
      'car-truck-10k': 'Vrachtwagen 10 ton',
      'car-semi-trailer': 'Trekker-oplegger',
      'car-truck-trailer': 'Vrachtwagen-aanhangwagen'
  	}
  },
  fr: {    
  	cars: {
      'car-basic': 'Voiture',
      'car-light-van': 'Camionette Légère',
      'car-delivery-van': 'Camionette',
      'car-delivery-van-xl': 'Camionette extra grande',
      'car-box-van': 'Camionette déménagement',
      'car-truck-5k': 'Camion 5 tonnes',
      'car-truck-10k': 'Camion 10 tonnes',
      'car-semi-trailer': 'Semi-remorque',
      'car-truck-trailer': 'Ensemble camion-remorque'
  	}  	
  }
}
